import { CanvasComponent, Point } from '@ardoq/yfiles';

const graphLocationToPageLocation = (
  canvasComponent: CanvasComponent,
  world: Point
) =>
  canvasComponent.viewToPageCoordinates(
    canvasComponent.worldToViewCoordinates(world)
  );

export { graphLocationToPageLocation };
